import { render } from "./RightSideBar.vue?vue&type=template&id=645b6a50"
import script from "./RightSideBar.vue?vue&type=script&lang=js"
export * from "./RightSideBar.vue?vue&type=script&lang=js"

import "./RightSideBar.vue?vue&type=style&index=0&id=645b6a50&lang=css"

import exportComponent from "C:\\Users\\Maraki(Lika)\\Desktop\\zowitech work\\seregela_frontend_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__